import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { SuperTicketDetailsComponent } from '../superadmin/super-ticket-details/super-ticket-details.component';
import { SuperTicketComponent } from '../superadmin/super-ticket/super-ticket.component';
import { SuperadminComponent } from '../superadmin/superadmin.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { MyTicketComponent } from './my-ticket/my-ticket.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';



const routes: Routes = [
  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'create-ticket', component: CreateTicketComponent, pathMatch: 'full' },
      { path: 'my-ticket', component: MyTicketComponent, pathMatch: 'full' },
      { path: 'ticket-details', component: TicketDetailsComponent, pathMatch: 'full' }
    ]
},
{ 
  path: '', 
  component: SuperadminComponent,
  children: [
    { path: 'superadmin/super-ticket', component: SuperTicketComponent, pathMatch: 'full' },
    { path: 'superadmin/super-ticket-details', component: SuperTicketDetailsComponent, pathMatch: 'full' }
  ]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TicketRoutingModule { }
